import React, { Component } from 'react'
import { connect } from 'react-redux'
import SettingMenu from '../../../constants/menu/setting'
import { authService } from '../../../services'

// UI
import { Page } from '../../../components'
import { Permissions } from '../../../constants'
import Form from 'antd/lib/form'
import Tabs from 'antd/lib/tabs'

import './styles.css'

import Status from './Status'

const pageSize = 20
const { Item: FormItem } = Form
const TabPane = Tabs.TabPane

const settingTitle = 'Tasks'
const settingType = 'sc-task'

export class SettingTask extends Component {
  constructor (props) {
    super(props)
    this.state = {
      addStatus: false,
      currentPage: 1,
      activeTab: '1',
      filter: {},
      modal: {
        item: { link: {} },
        show: false
      },
      modalShow: false,
      searchText: '',
      selectedItem: { _id: null },
      sort: {}
    }
  }

  componentDidMount () {
    const { currentPage } = this.state

    // const tab = (new URLSearchParams(window.location.search)).get("t")
    // this.setState({ activeTab: tab === 'rateset' ? '2' : (tab === 'fundmanager' ? '5' : '1') })
  }

  hideModal = () => {
    const { form } = this.props
    const { modal } = this.state
    const { resetFields } = form
    resetFields()
    modal.item = { link: {} }
    modal.show = false
    this.setState({ modal, selectedItem: {} })
  }

  showModal = () => {
    const { modal } = this.state
    modal.show = true
    this.setState({ modal })
  }

  addStatus = () => {
    this.setState({ addStatus: true })
  }

  onTabChange = (key) => {
    this.setState({ activeTab: key })
  }

  hasAccess (accessLevel) {
    return authService.hasAccess(accessLevel)
  }

  render () {
    const { addStatus, activeTab } = this.state

    return (
      <Page.Body>
        <Page.Left>
          <Page.Menu title='Home' menu={SettingMenu} />
        </Page.Left>

        <Page.Content full>
          <Page.Header title={settingTitle} />

          <Tabs defaultActiveKey='1' activeKey={activeTab} onChange={this.onTabChange}>
            { this.hasAccess(Permissions.SETTING.TASKSTATUS.LIST)
              ? <TabPane tab='Status' key='1'>
                <div className='header-action'>
                  { this.hasAccess(Permissions.SETTING.TASKSTATUS.CREATE)
                    ? <div className='btn' onClick={() => this.addStatus()}>
                      Add Status
                    </div>
                    : null }
                </div>
                <Status onAdd={addStatus} onComplete={() => this.setState({ addStatus: false })} />
              </TabPane>
              : null }
          </Tabs>

        </Page.Content>

      </Page.Body>
    )
  }
}

const mapDispatchToProps = {
}

const mapStateToProps = (state) => {
  return state
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(SettingTask))
